import { formatDateYMD } from "@unleashed-admin/utils/dateUtils";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export interface AdminBookingState {
  selectedEventDate: string;
  showAllBookings: boolean;
}

const initialState: AdminBookingState = {
  selectedEventDate: formatDateYMD(new Date()),
  showAllBookings: false
};

export const BookingSlice = createSlice({
  name: "adminBookingSlice",
  initialState,
  reducers: {
    setSelectedEventDate: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        selectedEventDate: action.payload
      };

    },
    setShowAllBookings:(state, action: PayloadAction<boolean>) => {
      return  {
        ...state,
        showAllBookings:action.payload
      };
    }
  }
});

export const {
  setSelectedEventDate,
  setShowAllBookings
} = BookingSlice.actions;
